export default {
      id: "circle__radius-usage",
      viewBox: "0 0 25 40",
      url: __webpack_public_path__ + "img/icons.svg#circle__radius",
      toString: function () {
        return this.url;
      }
    }